import { useTheme } from '@mui/material';
import Flag from 'react-world-flags';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import { getCountryName } from '../../../utils/countryUtils';

export type CountryPerformanceItemProps = {
  countryCode: string;
  percentage: string;
  total: number;
};

const CountryPerformanceItem = ({
  countryCode,
  percentage,
  total,
}: CountryPerformanceItemProps) => {
  const { spacing } = useTheme();
  const countryName = getCountryName(countryCode);

  return (
    <DSBox
      sx={{
        display: 'grid',
        alignItems: 'center',
        background: '#323232',
        borderRadius: '100px',
        gap: spacing(4),
        minHeight: '40px',
        gridTemplateColumns: '2fr 1fr 1fr',
        marginBottom: spacing(1.5),
      }}
    >
      <DSBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing(1.5),
        }}
      >
        <DSBox
          sx={{
            width: spacing(7),
            height: spacing(7),
            borderRadius: '50%',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <Flag
            code={countryCode}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            alt={`${countryName} Flag`}
          />
        </DSBox>
        <DSTypography variant="subtitle1">{countryName}</DSTypography>
      </DSBox>
      <DSTypography variant="body1">{percentage}</DSTypography>
      <DSTypography variant="body1">{total}</DSTypography>
    </DSBox>
  );
};

export default CountryPerformanceItem;
